module.exports = __webpack_public_path__ + "img/ml.9af39dcb.png";